import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AppSettings } from '../../../app/app.settings';
import { TabStorageService } from '../tabstorage/tabstorage.service';

export type BrandDomainTarget = 'qa' | 'demo';

@Injectable()
export class BrandDomainsService {
  infraMgmtEndpoint = AppSettings.getInfraManagementEndpoint();
  apiEndpoint = AppSettings.getEndpoint();

  constructor(public http: HttpClient) {}

  getBrandDomains(target?: BrandDomainTarget): Promise<any> {
    return this.http
      .get(`${this.infraMgmtEndpoint}/brand-dns`, this.withTarget(this.getInfraHeaders(), target))
      .toPromise();
  }

  createBrandDomain(subDomain: string, target?: BrandDomainTarget): Promise<any> {
    const body: { subDomain: string; target?: BrandDomainTarget } = { subDomain };
    if (target) {
      body.target = target;
    }
    return this.http
      .put(`${this.infraMgmtEndpoint}/brand-dns`, body, { headers: this.getInfraHeaders() })
      .toPromise();
  }

  deleteBrandDomain(subDomain: string, target?: BrandDomainTarget): Promise<any> {
    return this.http
      .delete(
        `${this.infraMgmtEndpoint}/brand-dns/${encodeURIComponent(subDomain)}`,
        this.withTarget(this.getInfraHeaders(), target),
      )
      .toPromise();
  }

  getInfraMgmtToken(): Promise<any> {
    const apiEndpoint = this.apiEndpoint.replace(/\/+$/, '');
    return this.http
      .get(`${apiEndpoint}/auth/infra-mgmt`)
      .toPromise()
      .then((res: any) => {
        const token = res?.jwt || res?.token || '';
        if (token) {
          TabStorageService.setStorage(TabStorageService.INFRA_MGMT_TOKEN, token);
        }
        return res;
      });
  }

  private getInfraHeaders(): HttpHeaders {
    const token = TabStorageService.getStorage(TabStorageService.INFRA_MGMT_TOKEN);
    if (!token) {
      return new HttpHeaders();
    }
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'x-infra-mgmt-auth': token,
    });
  }

  private withTarget(
    headers: HttpHeaders,
    target?: BrandDomainTarget,
  ): { headers: HttpHeaders; params?: HttpParams } {
    if (!target) {
      return { headers };
    }
    return {
      headers,
      params: new HttpParams().set('target', target),
    };
  }
}
